import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 260px;
  background: radial-gradient(circle, rgb(53, 82, 171), rgb(6, 13, 34));

  &.stylizedBackgroundOn {
    background-size: 60%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: '#060d22';
  }

  canvas {
    width: 100%;
    height: 100%;
  }
`;
